import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { WebSocketProvider } from "../../contexts/WebSocketContext";

function WebSocketWithToken({ children }) {
  const { isAuthenticated } = useContext(AuthContext);
  return <WebSocketProvider connected={isAuthenticated}>{children}</WebSocketProvider>;
}

export default WebSocketWithToken;
